<svelte:options
  customElement={{
    tag: "ofc-conversational-search-list-entry-v1",
    props: {
      pbk: { type: "String" }
    },
  }}
/>

<script lang="ts">
    import ListEntryV1 from "./ListEntryV1.svelte";
    import type {InitialTopicMessage} from "./InitialTopicMessage";

    const apiEndpoint = `/conversation/initial-topic-messages`;

    let { pbk }: { pbk?: string } = $props();

    async function getStyledListMessageFromPbk(pbkValue: string): Promise<string | undefined> {
        const response = await fetch(`${apiEndpoint}/${pbkValue}`);

        if (!response) {
            throw new Error(`Failed to fetch entry message for pbk: ${pbkValue}`);
        }

        if (response.status === 404) {
            return undefined;
        }

        if (!response.ok) {
            throw new Error(`Failed to fetch entry message: ${response.status}`);
        }

        const data = await response.json() as InitialTopicMessage;
        return data["list-message-styled"];
    }

    const messagePromise = $derived(pbk ? getStyledListMessageFromPbk(pbk) : Promise.resolve(undefined));
</script>


{#await messagePromise}
    <!-- Optional: Add a loading state -->
{:then styledListMessage}
    {#if styledListMessage}
        <ListEntryV1 message={styledListMessage} url={`/chat/?list_pbk=${pbk}`} />
    {/if}
{:catch error}
    <!-- Optional: Add error handling UI -->
{/await}

